/**
 * 快捷工具栏通用 UI：图标按钮、AI 花字按钮、图表编辑数据按钮。
 */
import React from 'react';
import { Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { BaseLayerViewType } from '@/version-types';

/** 带 Tooltip 的单图标操作项，与图层快捷条样式一致 */
export interface IShortcutToolbarIconItemProps {
    name: string;
    title: string;
    onClick: (e: React.MouseEvent) => void;
    onMouseDown?: (e: React.MouseEvent) => void;
}

/** 单图标 + 顶部 Tooltip */
export const ShortcutToolbarIconItem: React.FC<IShortcutToolbarIconItemProps> = React.memo(
    ({ name, title, onClick, onMouseDown }) => {
        return (
            <Tooltip placement="top" title={title}>
                <div
                    className="shortcut-list__item"
                    onMouseDown={onMouseDown}
                    data-type={BaseLayerViewType.SHORTCUT}
                    onClick={onClick}
                >
                    <div className="link-icon">
                        <IconFont fontSize={16} name={name} />
                    </div>
                </div>
            </Tooltip>
        );
    },
);

/** AI 花字：独立 AiTools 图标样式 */
export const ShortcutToolbarAiTextItem: React.FC<{ onClick?: (e: React.MouseEvent) => void }> = React.memo(
    ({ onClick }) => {
        return (
            <Tooltip placement="top" title="AI花字">
                <div
                    className="shortcut-list__item "
                    data-type={BaseLayerViewType.SHORTCUT}
                    onClick={(e) => onClick?.(e)}
                >
                    <div className="l-operate__none-event link-icon mt-ai-nav">
                        <IconFont name="AiTools" fontSize={16} color="var(--content-list-primary)" />
                    </div>
                </div>
            </Tooltip>
        );
    },
);

/** 图表图层：编辑数据（图标 + 文案） */
export const ShortcutToolbarChartEditItem: React.FC<{ onClick?: (e: React.MouseEvent) => void }> = React.memo(
    ({ onClick }) => {
        const { $t } = useLocaleStore();
        return (
            <div
                className="shortcut-list__item mt-chart-editor-data-nav"
                data-type={BaseLayerViewType.SHORTCUT}
                onClick={(e) => onClick?.(e)}
            >
                <div className="link-icon">
                    <IconFont name="EditBold" fontSize={16} color="var(--content-system-primary)" />
                    <span>{$t((v) => v.baseLayer.shortcutOperate.editChartData)}</span>
                </div>
            </div>
        );
    },
);
